export const colors = [
  ["красный", "#fc2c03"],
  ["синий", "#2e20fb"],
  ["зелёный", "#3cbf33"],
  ["жёлтый", "#ffe007"],
  ["чёрный", "#000"],
  ["оранжевый", "#ff8c00"],
  ["розовый", "#ff0095"],
  ["голубой", "#00e1ff"],
  ["фиолетовый", "#7b32a8"]
];
